import { uploadFile } from "./uploads"

export const uploadTransform = (field) => {
    return async (data, options) => {
        console.log(data)
        const image = data[field]
        if (!image || (options?.previousData[field] && options?.previousData[field].src === image.src))
            return data

        data[field] = await uploadFile(image.rawFile)
        console.log(data)
        return data
    }
}